import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"user\"><title>user</title><g id=\"user_Layer_8\" data-name=\"Layer 8\"><path d=\"M10.5,10.5A4.2766,4.2766,0,0,1,6.5,6a4.2766,4.2766,0,0,1,4-4.5,4.2766,4.2766,0,0,1,4,4.5A4.2766,4.2766,0,0,1,10.5,10.5Zm0-8A3.2829,3.2829,0,0,0,7.5,6a3.2829,3.2829,0,0,0,3,3.5,3.2829,3.2829,0,0,0,3-3.5A3.2829,3.2829,0,0,0,10.5,2.5Z\" /><path d=\"M18.5,20h-1V18.9561a6.7524,6.7524,0,0,0-7-6.4561,6.7524,6.7524,0,0,0-7,6.4561V20h-1V18.9561a7.7512,7.7512,0,0,1,8-7.4561,7.7512,7.7512,0,0,1,8,7.4561Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/user.svg
// module id = Km1V
// module chunks = 4